<!-- 新闻列表 -->
<template>
  <div id="noticeList">
    <headerVue></headerVue>
    <div class="container">
      <!-- 通知列表 -->
      <div style="display: flex;justify-content: center;margin-top: 10px;" v-if="$route.query.navName">
        <h3>{{ $route.query.navName }}</h3>
      </div>
      <div class="center" v-if="noticeList != null && noticeList.length !== 0">
        <div class="content Memorabilia" v-for="item in noticeList" :key="item.id">
          <div style="display: flex;justify-content: flex-start;flex:1">
            <img src="../../assets/image/picture/icon_local1.png" />
            <div class="title_Memorabilia" @click="toDetail(item.id)">{{ item.title }}</div>
          </div>
          <div class="time_Memorabilia">{{ item.releaseTime }}</div>
        </div>
      </div>
      <div v-if="noticeList != null && noticeList.length == 0">
        <p style="
              color: #ccc;
              text-align: center;
              line-height: 230px;
              font-size: 28px;
            ">
          暂无数据
        </p>
      </div>
      <!-- 分页 -->
      <el-pagination class="page" style="margin-top: 16px;float: right;margin-right: 10px;" background
        layout="total, sizes, prev, pager, next, jumper" :total="total" :page-sizes="[10]" :page-size="query.pageSize"
        :current-page="query.currentPage" @size-change="changePageSize" @current-change="currentPage">
      </el-pagination>
      <div class="load-more" style="text-align: center">
        <el-button v-if="total > 10 && query.pageSize * query.currentPage < total" @click="loadMore" class="btn-more"
          type="primary" style="background-color: #0b7dda;">
          加载更多
        </el-button>
      </div>
    </div>
    <footerVue></footerVue>
  </div>
</template>
  
<script>
import headerVue from "../index/header.vue";
import footerVue from "../foot/foot.vue";
export default {
  name: "newsSecondDetail",
  data() {
    return {
      noticeList: null,
      total: 0,
      // 分页
      pageData: {
        // 一页几条
        pageSize: 10,
        // 当前页数
        currentPage: 1,
      },
      query: {
        // 当前页数
        currentPage: 1,
        // 一页几条
        pageSize: 10,
      },
      // isLoading: true
    };
  },
  created() {
    this.getArticleList();
  },
  methods: {
    async loadMore() {
      this.query.currentPage++;
      this.getArticleList();
    },
    toDetail(_id) {
      // console.log('ididid',_id);
      if (this.$route.query.navName === '电子期刊') {
        this.$router.push(`/newsDetail?tm=${_id}`);
      } else {
        this.$router.push(`/newsDetail?tm=${_id}`)
      }

      // this.$router.push({ name: "routeNewsDetail", params: { id: _id } });
    },
    async getArticleList() {
      // console.log('关键字',this.$route.params.keyVal);
      if (this.$route.query.navName === '电子期刊') {
        let res = await this.$api.nav.getEBook();
        // console.log('电子期刊', res);
        this.noticeList = res.data.rows
        this.total = res.data.total
        // console.log('this.noticeList',this.noticeList);
      } else {
        let res = await this.$api.nav.getArticle(
          this.$route.query.tm,
          this.query.currentPage,
          this.query.pageSize,
          1,
          this.$route.query.keyVal,
          this.$route.query.year,
          this.$route.query.navName
        );
        // console.log('ressssssssssssss', res);
        this.noticeList = res.data.rows;
        this.total = res.data.total;
        // this.isLoading = false
        // console.log(this.noticeList);
      }
    },
    // args是默认参数，表示一页多少条
    changePageSize(args) {
      // console.log(args);
      this.pageData.pageSize = args;
      this.query.pageSize = args;
      // 重新更新页面
      this.getArticleList();
    },
    // args是默认参数，表示当前是第几页
    currentPage(args) {
      // console.log(args);
      this.pageData.currentPage = args;
      this.query.currentPage = args;
      // 重新更新页面
      this.getArticleList();
    },
  },
  components: {
    headerVue,
    footerVue,
  },
  watch: {
    $route(to, from) {
      this.getArticleList();
    },
  },
};
</script>
 
  
<style lang="scss" scoped>
#noticeList {
  background-color: #f5f5f5;
}

.load-more {
  display: none;
}

.container {
  background-color: white;
  padding: 10px 0px;
  margin-top: 20px;
  margin-left: auto;
  margin-right: auto;

  h3 {
    border-radius: 0px 10px 0px 10px;
    background-color: #0b7dda;
    color: white;
    font-size: 22px;
    height: 50px;
    line-height: 50px;
    position: relative;
    padding: 0 12px;
  }

  .center {
    .content {
      display: flex;
      align-items: center;
      padding: 17px;
      border-bottom: 1px solid #f0f0f0;
      position: relative;

      &:hover {
        color: #3181d1;
        transition: all 0.5s linear;
        cursor: pointer;
      }

      img {
        margin-right: 10px;
      }

      .title_Memorabilia {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }

      .time_Memorabilia {
        font-size: 14px;
        color: #999999;
      }
    }
  }
}

.Memorabilia {
  // width: 1200px;
  width: 100%;
  box-sizing: border-box;
}

.content:hover .title {
  color: #3181d1;
  transition: all 0.5s linear;
  cursor: pointer;
}

.page {
  margin-top: 40px;
  text-align: center;
}

.el-pagination .el-select .el-input .el-input__inner {
  padding-right: 10px;
}

.el-input__suffix {
  display: none;
}

@media screen and (max-width: 768px) {
  .load-more {
    display: block;
  }

  .page {
    display: none;
  }
}
</style>
